module.exports = __webpack_public_path__ + "img/login-check-error.42f28952.svg";